const CEC_URL = `${process.env.REACT_APP_SCO_ORIGIN_URL}`
const DELIVERY_EVENT_API = `${CEC_URL}/ecommerce/delivery-event`


const DeliveryEventApiUrls = {
  GET_BY_REF_NO: `${DELIVERY_EVENT_API}/deliveryOrderRefNo/`
}

export default DeliveryEventApiUrls
